export enum SurveyDataTypes {
	pastSurveysCount = 'pastSurveys',
	activeSurveysCount = 'ongoingSurveys',
	scheduledSurveysCount = 'scheduledSurveys',
}

export type ISurveyData = {
	[key in SurveyDataTypes]: number;
};
